import { computed } from "vue";
import { useStateStore } from "composables/useStateStore";

export const useDebug = () => {
  const stateStore = useStateStore();

  const groupedState = computed(() => {
    const groups: Record<string, any[]> = {};
    for (const [key, prop] of Object.entries(stateStore.state)) {
      const type = prop.type || "unknown";
      if (!groups[type]) groups[type] = [];
      groups[type].push({ key, prop });
    }
    return groups;
  });

  return { groupedState };
};
